const navContainer = document.getElementById('navbar_holder');
const navHolder = document.getElementById('navbar_holder_label');
const mobileSticker = document.getElementById('mobile_sticker');
const mobileNavholder = document.getElementById('mobile-nav-holder');
const closeImage = document.querySelector('.LATClose01');
const menuImage = document.querySelector('.LATMenu');
const sticky = navContainer.offsetTop;

var stick = function () {
  if (window.pageYOffset >= sticky) {
    navContainer.classList.add('sticky');
    navHolder.style.display = 'none';
    mobileSticker.style.display = 'flex';
    mobileNavholder.style.display = 'none';
  } else {
    navContainer.classList.remove('sticky');
    navHolder.style.display = 'block';
    mobileSticker.style.display = 'none';
    mobileNavholder.style.display = 'block';
  }
};

window.onscroll = () => stick();

mobileSticker.addEventListener('click', () => {
  toggleNav(closeImage);
  toggleNav(menuImage);
  toggleNav(mobileNavholder);
});

const toggleNav = (ele) => {
  ele.style.display = ele.style.display == 'none' ? 'block' : 'none';
};
